export default __webpack_public_path__ + "static/media/purse.051136aa.png";